export const types = {
    SET_VEP_FILTERS: "afipPaymentLink/SET_VEP_FILTERS",
    CLEAN_VEP_FILTERS: "afipPaymentLink/CLEAN_VEP_FILTERS",

    CLEAN_VEP_LIST: "afipPaymentLink/CLEAN_VEP_LIST",

    LIST_VEPS_REQUEST: "afipPaymentLink/LIST_VEPS_REQUEST",
    LIST_VEPS_FAILURE: "afipPaymentLink/LIST_VEPS_FAILURE",
    LIST_VEPS_SUCCESS: "afipPaymentLink/LIST_VEPS_SUCCESS",

    LIST_TAXPAYERS_REQUEST: "afipPaymentLink/LIST_TAXPAYERS_REQUEST",
    LIST_TAXPAYERS_FAILURE: "afipPaymentLink/LIST_TAXPAYERS_FAILURE",
    LIST_TAXPAYERS_SUCCESS: "afipPaymentLink/LIST_TAXPAYERS_SUCCESS",

    ADD_TAXPAYER_REQUEST: "afipPaymentLink/ADD_TAXPAYER_REQUEST",
    ADD_TAXPAYER_FAILURE: "afipPaymentLink/ADD_TAXPAYER_FAILURE",
    ADD_TAXPAYER_SUCCESS: "afipPaymentLink/ADD_TAXPAYER_SUCCESS",

    DELETE_TAXPAYER_REQUEST: "afipPaymentLink/DELETE_TAXPAYER_REQUEST",
    DELETE_TAXPAYER_FAILURE: "afipPaymentLink/DELETE_TAXPAYER_FAILURE",
    DELETE_TAXPAYER_SUCCESS: "afipPaymentLink/DELETE_TAXPAYER_SUCCESS",

    DELETE_VEP_REQUEST: "afipPaymentLink/DELETE_VEP_REQUEST",
    DELETE_VEP_FAILURE: "afipPaymentLink/DELETE_VEP_FAILURE",
    DELETE_VEP_SUCCESS: "afipPaymentLink/DELETE_VEP_SUCCESS",

    ACCESS_AFIP_PORTAL_REQUEST: "afipPaymentLink/ACCESS_AFIP_PORTAL_REQUEST",
    ACCESS_AFIP_PORTAL_FAILURE: "afipPaymentLink/ACCESS_AFIP_PORTAL_FAILURE",
    ACCESS_AFIP_PORTAL_SUCCESS: "afipPaymentLink/ACCESS_AFIP_PORTAL_SUCCESS",

    SET_VEP_PAYMENT_DATA: "afipPaymentLink/SET_VEP_PAYMENT_DATA",

    DOWNLOAD_VEP_DETAIL_REQUEST: "afipPaymentLink/DOWNLOAD_VEP_DETAIL_REQUEST",
    DOWNLOAD_VEP_DETAIL_FAILURE: "afipPaymentLink/DOWNLOAD_VEP_DETAIL_FAILURE",
    DOWNLOAD_VEP_DETAIL_SUCCESS: "afipPaymentLink/DOWNLOAD_VEP_DETAIL_SUCCESS",

    PROCESS_VEP_PAYMENT_REQUEST: "afipPaymentLink/PROCESS_VEP_PAYMENT_REQUEST",
    PROCESS_VEP_PAYMENT_FAILURE: "afipPaymentLink/PROCESS_VEP_PAYMENT_FAILURE",
    PROCESS_VEP_PAYMENT_SUCCESS: "afipPaymentLink/PROCESS_VEP_PAYMENT_SUCCESS",

    GET_PAYMENT_SCHEDULE_REQUEST: "afipPaymentLink/GET_PAYMENT_SCHEDULE_REQUEST",
    GET_PAYMENT_SCHEDULE_FAILURE: "afipPaymentLink/GET_PAYMENT_SCHEDULE_FAILURE",
    GET_PAYMENT_SCHEDULE_SUCCESS: "afipPaymentLink/GET_PAYMENT_SCHEDULE_SUCCESS",

    GET_DEBT_BY_CUIT_REQUEST: "afipPaymentLink/GET_DEBT_BY_CUIT_REQUEST",
    GET_DEBT_BY_CUIT_FAILURE: "afipPaymentLink/GET_DEBT_BY_CUIT_FAILURE",
    GET_DEBT_BY_CUIT_SUCCESS: "afipPaymentLink/GET_DEBT_BY_CUIT_SUCCESS",

    CLEAN_HAS_SEARCH_CUIT_FLAG: "afipPaymentLink/CLEAN_HAS_SEARCH_CUIT_FLAG",

    CLEAN_DEBT: "afipPaymentLink/CLEAN_DEBT",

    SET_SERVICES_PAYMENT_DATA: "afipPaymentLink/SET_SERVICES_PAYMENT_DATA",
    CLEAN_SERVICES_PAYMENT_DATA: "afipPaymentLink/CLEAN_SERVICES_PAYMENT_DATA",

    AFIP_SERVICES_ADD_ENTITY_REQUEST: "afipPaymentLink/AFIP_SERVICES_ADD_ENTITY_REQUEST",
    AFIP_SERVICES_ADD_ENTITY_SUCCESS: "afipPaymentLink/AFIP_SERVICES_ADD_ENTITY_SUCCESS",
    AFIP_SERVICES_ADD_ENTITY_FAILURE: "afipPaymentLink/AFIP_SERVICES_ADD_ENTITY_FAILURE",

    PROCESS_SERVICES_PAYMENT_REQUEST: "afipPaymentLink/PROCESS_SERVICES_PAYMENT_REQUEST",
    PROCESS_SERVICES_PAYMENT_FAILURE: "afipPaymentLink/PROCESS_SERVICES_PAYMENT_FAILURE",
    PROCESS_SERVICES_PAYMENT_SUCCESS: "afipPaymentLink/PROCESS_SERVICES_PAYMENT_SUCCESS",

    ADD_SERVICE_PRE_REQUEST: "afipPaymentLink/ADD_SERVICE_PRE_REQUEST",
    ADD_SERVICE_PRE_FAILURE: "afipPaymentLink/ADD_SERVICE_PRE_FAILURE",
    ADD_SERVICE_PRE_SUCCESS: "afipPaymentLink/ADD_SERVICE_PRE_SUCCESS",

    VERIFY_SERVICE_SCHEDULED_REQUEST: "afipPaymentLink/VERIFY_SERVICE_SCHEDULED_REQUEST",
    VERIFY_SERVICE_SCHEDULED_FAILURE: "afipPaymentLink/VERIFY_SERVICE_SCHEDULED_FAILURE",
    VERIFY_SERVICE_SCHEDULED_SUCCESS: "afipPaymentLink/VERIFY_SERVICE_SCHEDULED_SUCCESS",

    AD_SERVICE_LIST_REQUEST: "afipPaymentLink/AD_SERVICE_LIST_REQUEST",
    AD_SERVICE_LIST_FAILURE: "afipPaymentLink/AD_SERVICE_LIST_FAILURE",
    AD_SERVICE_LIST_SUCCESS: "afipPaymentLink/AD_SERVICE_LIST_SUCCESS",

    AD_SERVICE_DELETE_REQUEST: "afipPaymentLink/AD_SERVICE_DELETE_REQUEST",
    AD_SERVICE_DELETE_FAILURE: "afipPaymentLink/AD_SERVICE_DELETE_FAILURE",
    AD_SERVICE_DELETE_SUCCESS: "afipPaymentLink/AD_SERVICE_DELETE_SUCCESS",

    AD_SERVICE_EDIT_REQUEST: "afipPaymentLink/AD_SERVICE_EDIT_REQUEST",
    AD_SERVICE_EDIT_FAILURE: "afipPaymentLink/AD_SERVICE_EDIT_FAILURE",
    AD_SERVICE_EDIT_SUCCESS: "afipPaymentLink/AD_SERVICE_EDIT_SUCCESS",

    NEW_SERVICE_PAYMENT_PRE_REQUEST: "afipPaymentLink/NEW_SERVICE_PAYMENT_PRE_REQUEST",
    NEW_SERVICE_PAYMENT_PRE_FAILURE: "afipPaymentLink/NEW_SERVICE_PAYMENT_PRE_FAILURE",
    NEW_SERVICE_PAYMENT_PRE_SUCCESS: "afipPaymentLink/NEW_SERVICE_PAYMENT_PRE_SUCCESS",

    LINK_SERVICE_REQUEST: "afipPaymentLink/LINK_SERVICE_REQUEST",
    LINK_SERVICE_FAILURE: "afipPaymentLink/LINK_SERVICE_FAILURE",
    LINK_SERVICE_SUCCESS: "afipPaymentLink/LINK_SERVICE_SUCCESS",

    RESET_SERVICE_PAYMENT_INFO: "afipPaymentLink/RESET_SERVICE_PAYMENT_INFO",

    GENERATE_SERVICE_PAYMENT_REQUEST: "afipPaymentLink/GENERATE_SERVICE_PAYMENT_REQUEST",
    GENERATE_SERVICE_PAYMENT_FAILURE: "afipPaymentLink/GENERATE_SERVICE_PAYMENT_FAILURE",
    GENERATE_SERVICE_PAYMENT_SUCCESS: "afipPaymentLink/GENERATE_SERVICE_PAYMENT_SUCCESS",

    SET_ADDED_SERVICE_PAYMENT_DATA: "afipPaymentLink/SET_ADDED_SERVICE_PAYMENT_DATA",
    CLEAN_ADDED_SERVICE_DATA: "afipPaymentLink/CLEAN_ADDED_SERVICE_DATA",

    LIST_PAYMENTS_REQUEST: "afipPaymentLink/LIST_PAYMENTS_REQUEST",
    LIST_PAYMENTS_FAILURE: "afipPaymentLink/LIST_PAYMENTS_FAILURE",
    LIST_PAYMENTS_SUCCESS: "afipPaymentLink/LIST_PAYMENTS_SUCCESS",

    SET_PAYMENTS_FILTER_OPEN: "afipPaymentLink/SET_PAYMENTS_FILTER_OPEN",

    SET_PAYMENTS_FILTERS: "afipPaymentLink/SET_PAYMENTS_FILTERS",
};

export const INITIAL_STATE = {
    vepFilters: null,
    vepsList: [],
    fetching: false,
    totalVepsListPages: 0,
    taxpayersList: [],
    totalTaxpayersListPages: 0,
    hasMoreData: false,
    fetchingAfipAccess: false,
    vepPaymentData: null,
    paymentSchedule: [],
    afipServicesDebt: [],
    cuitIsAdheredToAfipServices: false,
    hasSearchCuitServices: false,
    servicesPaymentData: null,
    fetchingCuit: false,
    categories: [],
    entities: [],
    adheredServicesList: {},
    concepts: [],
    linkServiceStatus: null,
    serviceIsAdhered: false,
    servicesPaymentDebt: null,
    addedServicePaymentData: null,
    paymentsList: null,
    isPaymentsFilterOpen: false,
    paymentsFilters: null,
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        vepFilters,
        vepsList,
        totalVepsListPages,
        taxpayersList,
        totalTaxpayersListPages,
        hasMoreData,
        vepPaymentData,
        paymentSchedule,
        afipServicesDebt,
        cuitIsAdheredToAfipServices,
        servicesPaymentData,
        categories,
        entities,
        adheredServicesList,
        concepts,
        serviceIsAdhered,
        servicesPaymentDebt,
        addedServicePaymentData,
        paymentsList,
        isPaymentsFilterOpen,
        paymentsFilters,
    } = action;

    switch (action.type) {
        case types.CLEAN_DEBT:
            return { ...state, afipServicesDebt: [] };
        case types.CLEAN_HAS_SEARCH_CUIT_FLAG:
            return { ...state, hasSearchCuitServices: false, cuitIsAdheredToAfipServices: false };
        case types.CLEAN_VEP_LIST:
            return { ...state, vepsList: [] };
        case types.CLEAN_VEP_FILTERS:
            return { ...state, vepFilters: null };
        case types.SET_VEP_FILTERS:
            return { ...state, vepFilters };
        case types.LIST_VEPS_REQUEST:
            return { ...state, fetching: true, hasMoreData: false };
        case types.LIST_VEPS_SUCCESS:
            return { ...state, fetching: false, vepsList, totalVepsListPages, hasMoreData };
        case types.LIST_VEPS_FAILURE:
            return { ...state, fetching: false };
        case types.LIST_TAXPAYERS_REQUEST:
            return { ...state, fetching: true, hasMoreData: false };
        case types.LIST_TAXPAYERS_SUCCESS:
            return { ...state, fetching: false, taxpayersList, totalTaxpayersListPages, hasMoreData };
        case types.LIST_TAXPAYERS_FAILURE:
            return { ...state, fetching: false };
        case types.ADD_TAXPAYER_REQUEST:
            return { ...state, fetching: true };
        case types.ADD_TAXPAYER_SUCCESS:
            return { ...state, fetching: false };
        case types.ADD_TAXPAYER_FAILURE:
            return { ...state, fetching: false };
        case types.DELETE_TAXPAYER_REQUEST:
            return { ...state, fetching: true };
        case types.DELETE_TAXPAYER_SUCCESS:
            return { ...state, fetching: false };
        case types.DELETE_TAXPAYER_FAILURE:
            return { ...state, fetching: false };
        case types.DELETE_VEP_REQUEST:
            return { ...state, fetching: true };
        case types.DELETE_VEP_SUCCESS:
            return { ...state, fetching: false };
        case types.DELETE_VEP_FAILURE:
            return { ...state, fetching: false };
        case types.ACCESS_AFIP_PORTAL_REQUEST:
            return { ...state, fetchingAfipAccess: true };
        case types.ACCESS_AFIP_PORTAL_SUCCESS:
            return { ...state, fetchingAfipAccess: false };
        case types.ACCESS_AFIP_PORTAL_FAILURE:
            return { ...state, fetchingAfipAccess: false };
        case types.SET_VEP_PAYMENT_DATA:
            return { ...state, vepPaymentData };
        case types.DOWNLOAD_VEP_DETAIL_REQUEST:
            return { ...state, fetchingDownload: true };
        case types.DOWNLOAD_VEP_DETAIL_FAILURE:
        case types.DOWNLOAD_VEP_DETAIL_SUCCESS:
            return { ...state, fetchingDownload: false };
        case types.PROCESS_VEP_PAYMENT_REQUEST:
            return { ...state, fetching: true };
        case types.PROCESS_VEP_PAYMENT_FAILURE:
        case types.PROCESS_VEP_PAYMENT_SUCCESS:
            return { ...state, fetching: false };
        case types.GET_PAYMENT_SCHEDULE_REQUEST:
            return { ...state, fetching: true };
        case types.GET_PAYMENT_SCHEDULE_SUCCESS:
            return { ...state, fetching: false, paymentSchedule };
        case types.GET_PAYMENT_SCHEDULE_FAILURE:
            return { ...state, fetching: false };
        case types.GET_DEBT_BY_CUIT_REQUEST:
            return { ...state, fetchingCuit: true };
        case types.GET_DEBT_BY_CUIT_SUCCESS:
            return {
                ...state,
                fetchingCuit: false,
                afipServicesDebt,
                cuitIsAdheredToAfipServices,
                hasSearchCuitServices: true,
            };
        case types.GET_DEBT_BY_CUIT_FAILURE:
            return { ...state, fetchingCuit: false };
        case types.SET_SERVICES_PAYMENT_DATA:
            return { ...state, servicesPaymentData };
        case types.CLEAN_SERVICES_PAYMENT_DATA:
            return { ...state, servicesPaymentData: null };
        case types.AFIP_SERVICES_ADD_ENTITY_REQUEST:
            return { ...state, fetching: true };
        case types.AFIP_SERVICES_ADD_ENTITY_FAILURE:
            return { ...state, fetching: false };
        case types.AFIP_SERVICES_ADD_ENTITY_SUCCESS:
            return { ...state, fetching: false, cuitIsAdheredToAfipServices: true };
        case types.PROCESS_SERVICES_PAYMENT_REQUEST:
            return { ...state, fetching: true };
        case types.PROCESS_SERVICES_PAYMENT_FAILURE:
        case types.PROCESS_SERVICES_PAYMENT_SUCCESS:
            return { ...state, fetching: false };
        case types.ADD_SERVICE_PRE_REQUEST:
            return { ...state, fetching: true };
        case types.ADD_SERVICE_PRE_FAILURE:
            return { ...state, fetching: false };
        case types.ADD_SERVICE_PRE_SUCCESS:
            return {
                ...state,
                fetching: false,
                categories: categories || state.categories,
                entities: entities || state.entities,
            };
        case types.VERIFY_SERVICE_SCHEDULED_REQUEST:
            return { ...state, fetching: true };
        case types.VERIFY_SERVICE_SCHEDULED_SUCCESS:
        case types.VERIFY_SERVICE_SCHEDULED_FAILURE:
            return { ...state, fetching: false };
        case types.AD_SERVICE_LIST_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.AD_SERVICE_LIST_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.AD_SERVICE_LIST_SUCCESS:
            return {
                ...state,
                fetching: false,
                adheredServicesList,
            };
        case types.AD_SERVICE_DELETE_REQUEST:
            return { ...state, fetching: true };
        case types.AD_SERVICE_DELETE_FAILURE:
            return { ...state, fetching: false };
        case types.AD_SERVICE_DELETE_SUCCESS:
            return { ...state, fetching: false };
        case types.AD_SERVICE_EDIT_REQUEST:
            return { ...state, fetching: true };
        case types.AD_SERVICE_EDIT_FAILURE:
            return { ...state, fetching: false };
        case types.AD_SERVICE_EDIT_SUCCESS:
            return { ...state, fetching: false };
        case types.NEW_SERVICE_PAYMENT_PRE_REQUEST:
            return { ...state, fetching: true, serviceIsAdhered: false };
        case types.NEW_SERVICE_PAYMENT_PRE_FAILURE:
            return { ...state, fetching: false, serviceIsAdhered: false, servicesPaymentDebt: null };
        case types.NEW_SERVICE_PAYMENT_PRE_SUCCESS:
            return {
                ...state,
                fetching: false,
                categories: categories || state.categories,
                entities: entities || state.entities,
                concepts: concepts || state.concepts,
                serviceIsAdhered: serviceIsAdhered || state.serviceIsAdhered,
                servicesPaymentDebt: servicesPaymentDebt || state.servicesPaymentDebt,
            };
        case types.RESET_SERVICE_PAYMENT_INFO:
            return {
                ...state,
                categories: [],
                entities: [],
                concepts: [],
                serviceIsAdhered: false,
                servicesPaymentDebt: null,
            };
        case types.LINK_SERVICE_REQUEST:
            return { ...state, fetching: true };
        case types.LINK_SERVICE_FAILURE:
            return { ...state, fetching: false, linkServiceStatus: true };
        case types.LINK_SERVICE_SUCCESS:
            return { ...state, fetching: false, linkServiceStatus: true };
        case types.GENERATE_SERVICE_PAYMENT_REQUEST:
            return { ...state, fetching: true };
        case types.GENERATE_SERVICE_PAYMENT_FAILURE:
        case types.GENERATE_SERVICE_PAYMENT_SUCCESS:
            return { ...state, fetching: false };
        case types.SET_ADDED_SERVICE_PAYMENT_DATA:
            return { ...state, addedServicePaymentData };
        case types.CLEAN_ADDED_SERVICE_DATA:
            return { ...state, addedServicePaymentData: null };
        case types.LIST_PAYMENTS_REQUEST:
            return { ...state, fetching: true };
        case types.LIST_PAYMENTS_FAILURE:
            return { ...state, fetching: false };
        case types.LIST_PAYMENTS_SUCCESS:
            return { ...state, fetching: false, paymentsList };
        case types.SET_PAYMENTS_FILTER_OPEN:
            return { ...state, isPaymentsFilterOpen };
        case types.SET_PAYMENTS_FILTERS:
            return { ...state, paymentsFilters };
        default:
            return state;
    }
};

export const actions = {
    cleanVepFilters: () => ({
        type: types.CLEAN_VEP_FILTERS,
    }),
    setVepFilters: (vepFilters) => ({
        type: types.SET_VEP_FILTERS,
        vepFilters,
    }),
    cleanVepsList: () => ({
        type: types.CLEAN_VEP_LIST,
    }),
    listVepsPending: (filters) => ({
        type: types.LIST_VEPS_REQUEST,
        filters,
        vepStatus: "PENDIENTE_PAGO",
    }),
    listVepsHistoric: (filters) => ({
        type: types.LIST_VEPS_REQUEST,
        filters,
        vepStatus: "PAGADO",
    }),
    listTaxpayer: (pageNumber) => ({
        type: types.LIST_TAXPAYERS_REQUEST,
        pageNumber,
    }),
    addTaxpayer: (params) => ({
        type: types.ADD_TAXPAYER_REQUEST,
        params,
    }),
    deleteTaxpayer: (params) => ({
        type: types.DELETE_TAXPAYER_REQUEST,
        params,
    }),
    deleteVep: (params) => ({
        type: types.DELETE_VEP_REQUEST,
        params,
    }),
    accessAfipPortal: () => ({
        type: types.ACCESS_AFIP_PORTAL_REQUEST,
    }),
    setVepPaymentData: (vepPaymentData) => ({
        type: types.SET_VEP_PAYMENT_DATA,
        vepPaymentData,
    }),
    downloadVepDetail: (vep, format, isHistoric, vepType) => ({
        type: types.DOWNLOAD_VEP_DETAIL_REQUEST,
        vep,
        format,
        isHistoric,
        vepType,
    }),
    processVepPayment: (params, formikBag) => ({
        type: types.PROCESS_VEP_PAYMENT_REQUEST,
        params,
        formikBag,
    }),
    getPaymentSchedule: (isArcaPayment) => ({
        type: types.GET_PAYMENT_SCHEDULE_REQUEST,
        isArcaPayment,
    }),
    getDebtByCuit: (cuit) => ({
        type: types.GET_DEBT_BY_CUIT_REQUEST,
        cuit,
    }),
    cleanHasSearchCuitFlag: () => ({
        type: types.CLEAN_HAS_SEARCH_CUIT_FLAG,
    }),
    cleanDebt: () => ({
        type: types.CLEAN_DEBT,
    }),
    setServicesPaymentData: (servicesPaymentData) => ({
        type: types.SET_SERVICES_PAYMENT_DATA,
        servicesPaymentData,
    }),
    cleanPaymentData: () => ({
        type: types.CLEAN_SERVICES_PAYMENT_DATA,
    }),
    afipServicesAddEntity: (cuit) => ({
        type: types.AFIP_SERVICES_ADD_ENTITY_REQUEST,
        cuit,
    }),
    processServicesPayment: (params) => ({
        type: types.PROCESS_SERVICES_PAYMENT_REQUEST,
        params,
    }),
    addServicePaymentPre: (params) => ({
        type: types.ADD_SERVICE_PRE_REQUEST,
        params,
    }),
    verifyServiceSchedule: (servicePaymentData) => ({
        type: types.VERIFY_SERVICE_SCHEDULED_REQUEST,
        servicePaymentData,
    }),
    adheredServicesList: () => ({
        type: types.AD_SERVICE_LIST_REQUEST,
    }),
    deleteAdheredService: (linkCode) => ({
        type: types.AD_SERVICE_DELETE_REQUEST,
        linkCode,
    }),
    editAdheredService: (linkCode, alias) => ({
        type: types.AD_SERVICE_EDIT_REQUEST,
        linkCode,
        alias,
    }),
    newServicePaymentPre: (params) => ({
        type: types.NEW_SERVICE_PAYMENT_PRE_REQUEST,
        params,
    }),
    linkService: (params, formikBag) => ({
        type: types.LINK_SERVICE_REQUEST,
        params,
        formikBag,
    }),
    resetServicePaymentInfo: () => ({
        type: types.RESET_SERVICE_PAYMENT_INFO,
    }),
    generateServicePayment: (params, formikBag) => ({
        type: types.GENERATE_SERVICE_PAYMENT_REQUEST,
        params,
        formikBag,
    }),
    setAddedServicePaymentData: (addedServicePaymentData) => ({
        type: types.SET_ADDED_SERVICE_PAYMENT_DATA,
        addedServicePaymentData,
    }),
    cleanAddedServicePaymentData: () => ({
        type: types.CLEAN_ADDED_SERVICE_DATA,
    }),
    listPaymentsHistory: (params) => ({
        type: types.LIST_PAYMENTS_REQUEST,
        params,
    }),
    setPaymentsFilterOpen: (isPaymentsFilterOpen) => ({
        type: types.SET_PAYMENTS_FILTER_OPEN,
        isPaymentsFilterOpen,
    }),
    setPaymentsFilters: (paymentsFilters) => ({
        type: types.SET_PAYMENTS_FILTERS,
        paymentsFilters,
    }),
};

export const selectors = {
    getFetching: ({ afipPaymentLink }) => afipPaymentLink.fetching,
    getFilters: ({ afipPaymentLink }) => afipPaymentLink.vepFilters,
    getVeps: ({ afipPaymentLink }) => afipPaymentLink.vepsList,
    totalVepsListPages: ({ afipPaymentLink }) => afipPaymentLink.totalVepsListPages,
    getTaxpayersList: ({ afipPaymentLink }) => afipPaymentLink.taxpayersList,
    totalTaxpayersListPages: ({ afipPaymentLink }) => afipPaymentLink.totalTaxpayersListPages,
    getHasMoreData: ({ afipPaymentLink }) => afipPaymentLink.hasMoreData,
    getFetchingAfipAccess: ({ afipPaymentLink }) => afipPaymentLink.fetchingAfipAccess,
    getVepPaymentData: ({ afipPaymentLink }) => afipPaymentLink.vepPaymentData,
    getFetchingDownload: ({ afipPaymentLink }) => afipPaymentLink.fetchingDownload,
    getPaymentSchedule: ({ afipPaymentLink }) => afipPaymentLink.paymentSchedule,
    getCuitIsAdhered: ({ afipPaymentLink }) => afipPaymentLink.cuitIsAdheredToAfipServices,
    getAfipServicesDebt: ({ afipPaymentLink }) => afipPaymentLink.afipServicesDebt,
    getHasSearchCuitServices: ({ afipPaymentLink }) => afipPaymentLink.hasSearchCuitServices,
    getServicesPaymentData: ({ afipPaymentLink }) => afipPaymentLink.servicesPaymentData,
    getFetchingCuit: ({ afipPaymentLink }) => afipPaymentLink.fetchingCuit,
    getCategories: ({ afipPaymentLink }) => afipPaymentLink.categories,
    getEntities: ({ afipPaymentLink }) => afipPaymentLink.entities,
    getAdheredServices: ({ afipPaymentLink }) => afipPaymentLink.adheredServicesList,
    getConcepts: ({ afipPaymentLink }) => afipPaymentLink.concepts,
    getLinkServiceStatus: ({ afipPaymentLink }) => afipPaymentLink.linkServiceStatus,
    serviceIsAdhered: ({ afipPaymentLink }) => afipPaymentLink.serviceIsAdhered,
    servicesPaymentDebt: ({ afipPaymentLink }) => afipPaymentLink.servicesPaymentDebt,
    getAddedServicePaymentData: ({ afipPaymentLink }) => afipPaymentLink.addedServicePaymentData,
    getPaymentsList: ({ afipPaymentLink }) => afipPaymentLink.paymentsList,
    isPaymentsFilterOpen: ({ afipPaymentLink }) => afipPaymentLink.isPaymentsFilterOpen,
    getPaymentsFilters: ({ afipPaymentLink }) => afipPaymentLink.paymentsFilters,
};
